import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISocketsState } from '../actions/sockets.actions';
import { sendMessage, authenticateSocket, connectSockets } from '../middlewares/sockets.middleware';

const initialState: ISocketsState  = {
  status: 'CLOSED',
}

const socketsSlice = createSlice({
  name: 'sockets',
  initialState: initialState,
  reducers: {
    connect(state, action: PayloadAction<string>) {
      if (action.payload === 'open') {
        state.status = 'OPEN';
      }
    },
    connectionState(state, action: PayloadAction<string>) {
      console.log('connectionState: ', action.payload);
      switch (action.payload) {
        case 'connecting':
          state.status = 'CONNECTING';
          break;
        case 'open':
          state.status = 'OPEN';
          break;
        case 'closed':
        case 'close':
          state.status = 'CLOSED';
          break;
        case 'closing':
          state.status = 'CLOSING';
          break;
        default:
          break;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(connectSockets.pending, (state) => {
      console.log(Date.now().toString())
      console.log('connectSockets.pending');
    });
    builder.addCase(connectSockets.fulfilled, (state, { payload }) => {
      console.log(Date.now().toString())
      console.log('connectSockets.fulfilled');
    });
    builder.addCase(connectSockets.rejected, (state, { payload }) => {
      console.log('connectSockets.rejected');
      if (payload) { // ???
        // state.error = "error loading"; // TODO: Translations
      }
    });

    builder.addCase(authenticateSocket.pending, (state) => {
      console.log(Date.now().toString())
      console.log('authenticateSocket.pending');
    });
    builder.addCase(authenticateSocket.fulfilled, (state) => {
      console.log(Date.now().toString())
      console.log('authenticateSocket.fulfilled');
    });
    builder.addCase(authenticateSocket.rejected, (state) => {
      console.log(Date.now().toString())
      console.log('authenticateSocket.rejected');
    });

    builder.addCase(sendMessage.pending, (state) => {
      console.log(Date.now().toString())
      console.log('sendMessage.pending');
    });
    builder.addCase(sendMessage.fulfilled, (state) => {
      console.log(Date.now().toString())
      console.log('sendMessage.fulfilled');
    });
    builder.addCase(sendMessage.rejected, (state) => {
      console.log(Date.now().toString())
      console.log('sendMessage.rejected');
    });

  },
});

export default socketsSlice;
export const socketsReducer = socketsSlice.reducer;
